<template>
    <b-container>
        <Breadcrumbs crumbString="Contact Us"></Breadcrumbs>
        <b-row>
            <b-col class="col-12 col-md-4 col-lg-4">
                <h2>{{ title }}</h2>
                <div>
                    <p>Please feel free to contact us directly. Our hope is to personally answer your questions and
                        offer helpful suggestions. We are happy to provide project quotes at no cost and look forward to assisting you.</p>
                  <p>Please contact your sales rep or project manager for a link to send us your files.</p>
                </div>
                <div class="contact-info">
                    <span><strong>enviroSIGNS</strong></span>
                    <span>2370 E Stringham Ave.</span>
                    <span>Salt Lake City, UT 84109</span>
                    <br>
                    <span>North Canton, Ohio Office</span>
                  <span><a href="mailto:tina@envirosigns.com">tina@envirosigns.com</a></span>
                    <br>
                    <span>(888) 492-5377</span>
                    <span>(801) 942-5812</span>
                    <span>(801) 943-6008 fax</span>
                    <span><a href="mailto:info@envirosigns.com">info@envirosigns.com</a></span>
                </div>
                <hr>
                <div>
                    <b-form v-if="formShow" @submit.prevent="submitForm" id="contact-form">
                        <b-form-group class="form-required" id="input-group-2" label="Your Name:" label-for="form-first">
                            <b-row>
                                <b-col class="col-sm-6 col-md-12 contact-form-last-name">
                                    <b-form-input id="form-first" v-model="form.first" required placeholder="First name"></b-form-input>
                                </b-col>
                                <b-col class="col-sm-6 col-md-12">
                                    <b-form-input id="form-last" v-model="form.last" required placeholder="Last name"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group class="form-required" label="Email:" label-for="form-email" description="We'll never share your email with anyone else.">
                            <b-form-input id="form-email" v-model="form.email" type="email" required placeholder="Email address"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Phone:" label-for="form-phone">
                          <b-form-input id="form-phone" v-model="form.phone" type="tel" pattern="\d*" title="Only numbers allowed" placeholder="Phone number"></b-form-input>
                        </b-form-group>

                        <b-form-group class="form-required" label="Subject:" label-for="form-subject">
                            <b-form-input id="form-subject" v-model="form.subject" type="text" required placeholder="Subject"></b-form-input>
                        </b-form-group>

                        <b-form-group class="form-required" label="Message:" label-for="form-message">
                            <b-form-textarea id="form-message" v-model="form.message" placeholder="Enter something..." required rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>

                        <b-form-group class="form-required">
                          <div ref="recaptcha" class="g-recaptcha" data-sitekey="6Lfe9_8UAAAAAE0VIGRjqRAo9XV8m8HrIhOOJJ0Q"></div>
                        </b-form-group>

                        <b-button type="submit" class="form-submit">Submit</b-button>
                    </b-form>
                    <div v-show="!formShow" id="form-response" class="form-message"></div>
                    <hr class="submit-hr">
                </div>
            </b-col>
            <b-col class="col-12 col-md-8 col-lg-8">
                <b-container class="pods-container">
                    <b-row>
                        <b-col class="col-12 col-md-6 col-lg-6">
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'interpretive' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/interpretive-sign-imageLOC.jpg" alt="Interpretive & Educational Signs">
                                    <span>Interpretive & Educational</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                                  <router-link :to="{ name: 'historical' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/historical-sign-imageLOC.jpg" alt="Historical Signs">
                                    <span>Historical</span>
                                  </router-link>
                                </b-col>
                                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                                  <router-link :to="{ name: 'commemorative' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/commemorative-sign-novalloy.jpg" alt="Commemorative Signs">
                                    <span>Commemorative</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                          <router-link :to="{ name: 'wayfinding' }">
                            <img width="100%" src="../../assets/images/pages/what-we-do/wayfinding-sign-weathering-steel.jpg" alt="Wayfinding">
                            <span>Identification & Wayfinding</span>
                          </router-link>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Breadcrumbs from '../Breadcrumbs.vue'
    import axios from 'axios'

    export default {
      components: {
        Breadcrumbs
      },

      data () {
        return {
          title: 'Contact Us',
          formShow: true,
          form: {
            first: '',
            last: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            recaptcha: ''
          }
        }
      },

      computed: {
        uri () {
          return window.location.href.substring(0, window.location.href.lastIndexOf('/'))
        }
      },

      mounted () {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
        document.head.appendChild(recaptchaScript)
      },

      methods: {
        submitForm: function () {
          const recpatchaValue = document.getElementById('g-recaptcha-response').value
          if (!recpatchaValue) {
            return
          }

          for (let elem of document.getElementById('contact-form').elements) {
            elem.disabled = true
          }

          this.form.recaptcha = recpatchaValue

          axios.post(
            `${this.uri}/static/contact.php`,
            JSON.stringify(this.form),
            {
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            }
          )
            .then((res) => {
              this.formShow = false
              let messageDiv = document.getElementById('form-response')
              messageDiv.innerHTML = res.data.message
              messageDiv.classList.add('success')
            })
            .catch((err) => {
              this.formShow = false
              let messageDiv = document.getElementById('form-response')
              messageDiv.innerHTML = err.response.data.message ? err.response.data.message : 'An error occurred please try again'
              messageDiv.classList.add('error')
              // Send GA event
              if (this.$ga) {
                this.$gtag.event('contact_error', {
                  'event_category': 'contact',
                  'event_label': err.response.data.message,
                  'value': 0
                })
              }
            })
        }
      }
}
</script>

<style lang="scss">
    @import '../../assets/css/contact.scss';
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue